/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace network_ui {

   export class VmMigrateSelectVmsPageService {

      static $inject = [
         "i18nService",
         "vmMigrateWizardConstants",
         "clarityModalService"
      ];

      constructor(private i18nService: any,
                  private wizardConstants: any,
                  private clarityModalService: any) {
      }

      public saveExpandedItem(
            itemId: string,
            allExpandedItemIds: string[]): void {

         let itemIdFound: string =
               _.find(allExpandedItemIds, (id: any) => {
                  return id === itemId;
               });

         if (!itemIdFound) {
            allExpandedItemIds.push(itemId);
         }
      }

      public saveCollapsedItem(
            itemId: string,
            allExpandedItemIds: string[]): void {

         if (itemId === this.wizardConstants.ALL_VMS_ITEM_ID) {
            allExpandedItemIds.splice(0, allExpandedItemIds.length);
         } else {
            let itemIndex: number =
                  allExpandedItemIds.indexOf(itemId);

            if (itemIndex !== -1) {
               allExpandedItemIds.splice(itemIndex, 1);
            }
         }
      }

      public restoreExpandedItems(
            allExpandedItemIds: string[],
            treeListWidget: any,
            treeListDataSource: any): void {
         if (!treeListDataSource || !treeListWidget || !allExpandedItemIds) {
            return;
         }

         let allVmsItem: any = this.findRootTreeListItem(treeListDataSource);

         if (allVmsItem) {
            if (allExpandedItemIds.length !== 0) {
               // Expand the `All VMs` item
               let allVmsListRow: any = treeListWidget.itemFor(allVmsItem);
               if (allVmsListRow && !allVmsListRow.expanded) {
                  treeListWidget.expand(allVmsListRow);
               }

               if (allExpandedItemIds.length > 1) {
                  // Expand the previously expanded VM items
                  this.expandVmItems(
                        allVmsItem,
                        allExpandedItemIds,
                        treeListWidget,
                        treeListDataSource);
               }
            }
         }
      }

      public updateTreeListCheckboxState(
            dataSource: any,
            dataItem: any,
            wizardScope: VmMigrateWizardScope): void {

         if (dataItem.isAccessible === false) {
            // Inaccessible items should not be checked
            return;
         }

         if (wizardScope.model.treeListItemData && dataItem) {

            if (dataItem.id === this.wizardConstants.ALL_VMS_ITEM_ID) {
               // The item is 'All VMs' item - check/uncheck all VMs and virtual NICs
               let hasInaccessibleItems: boolean = false;

               _.each(wizardScope.model.treeListItemData, (item) => {
                  if (item.isAccessible ||
                        item.id === this.wizardConstants.ALL_VMS_ITEM_ID) {
                     item.isChecked = dataItem.isChecked;
                     dataSource.pushUpdate(item);

                  } else if (item.isAccessible === false) {
                     hasInaccessibleItems = true;
                  }
               });

               if (dataItem.isChecked && hasInaccessibleItems) {
                  if (!wizardScope.flags.inaccessibilityWarningShown) {
                     this.showWarningDialog(wizardScope);
                  }
               }
            } else if (!dataItem.virtualEthernetCard) {
               // The item is a VM - check/uncheck the VM item and all its virtual NICs
               _.each(wizardScope.model.treeListItemData, (item) => {
                  if (item.isAccessible) {
                     if (dataItem.id === item.id &&
                           dataItem.parentId === item.parentId) {
                        // Check/uncheck the VM
                        item.isChecked = dataItem.isChecked;
                        dataSource.pushUpdate(item);

                        // Check/uncheck the root item if needed
                        this.checkUncheckParentItem(
                              dataSource,
                              item,
                              dataItem.isChecked,
                              wizardScope.model.treeListItemData);
                     }

                     // Check/uncheck the VM virtual NICs
                     if (dataItem.id === item.parentId) {
                        item.isChecked = dataItem.isChecked;
                        dataSource.pushUpdate(item);
                     }
                  }
               });
            } else {
               // The item is a virtual NIC - check/uncheck the item, its VM item and
               // the root item (if it is needed)
               for (let item of wizardScope.model.treeListItemData) {

                  if (dataItem.id === item.id &&
                        dataItem.parentId === item.parentId) {

                     if (item.isAccessible === false) {
                        // Do not check/uncheck the item
                        break;
                     }

                     // Check/uncheck the virtual NIC
                     item.isChecked = dataItem.isChecked;
                     dataSource.pushUpdate(item);

                     // Check/uncheck the parent VM item if needed
                     this.checkUncheckParentItem(
                           dataSource,
                           item,
                           dataItem.isChecked,
                           wizardScope.model.treeListItemData);

                     for (let listItem of wizardScope.model.treeListItemData) {
                        // Check/uncheck the root item if needed

                        if (dataItem.parentId === listItem.id) {
                           this.checkUncheckParentItem(
                                 dataSource,
                                 listItem,
                                 dataItem.isChecked,
                                 wizardScope.model.treeListItemData);

                           break;
                        }
                     }

                     break;
                  }
               }
            }
         }
      }

      public showWarningDialog(wizardScope: VmMigrateWizardScope) {
         this.clarityModalService.openConfirmationModal({
            title: this.i18nService.getString(
                  "NetworkUi", "SelectVmsToMigratePage" +
                  ".vmsWithInaccessibleDestinationSelected.title"),
            message: this.i18nService.getString(
                  "NetworkUi", "SelectVmsToMigratePage" +
                  ".vmsWithInaccessibleDestinationSelected.description"),
            submit: () => {
               wizardScope.flags.inaccessibilityWarningShown = true;
            },
            clarityIcon: {
               class: "is-warning",
               shape: "warning-standard",
               size: "32"
            },
            preserveNewlines: true,
            saveButtonLabel: this.i18nService.getString(
                  "Common", "alert.ok"),
            cancelButtonLabel: null,
            hideCancelButton: true
         });
      }

      private checkUncheckParentItem(
            dataSource: any,
            childItem: any,
            checkItem: boolean,
            treeListItemData: any[]): void {
         if (!childItem) {
            return;
         }

         if (checkItem) {
            // The child item is checked - check its parent item
            for (let item of treeListItemData) {
               if (childItem.parentId === item.id) {
                  item.isChecked = true;
                  dataSource.pushUpdate(item);
                  break;
               }
            }
         } else {// Uncheck item
            let hasCheckedPeer: boolean = false;

            // The item is unchecked - uncheck the parent item of the item
            // if it does not have checked peers
            for (let item of treeListItemData){
               if (childItem.parentId === item.parentId) {
                  if (item.isChecked) {
                     hasCheckedPeer = true;
                     break;
                  }
               }
            }

            if (!hasCheckedPeer) {
               for (let item of treeListItemData){
                  if (childItem.parentId === item.id) {
                     item.isChecked = false;
                     dataSource.pushUpdate(item);
                     break;
                  }
               }
            }
         }
      }

      private expandVmItems(
            allVmsItem: any,
            allExpandedItemIds: string[],
            treeListWidget: any,
            treeListDataSource: any): void {

         let vmItems: any[] = treeListDataSource.childNodes(allVmsItem);

         if (vmItems && vmItems.length > 0) {
            for (let vmItem of vmItems) {

               let itemIdFound: string =
                     _.find(allExpandedItemIds, (id: any) => {
                        return id === vmItem.id;
                     });

               if (itemIdFound) {
                  let vmItemRow: any = treeListWidget.itemFor(vmItem);
                  if (vmItemRow && !vmItemRow.expanded) {
                     treeListWidget.expand(vmItemRow);
                  }
               }
            }
         }
      }

      private findRootTreeListItem(treeListDataSource: any): any {
         if (!treeListDataSource) {
            return null;
         }

         return _.find(treeListDataSource.rootNodes(), (item: any) => {
            return item.id ===  this.wizardConstants.ALL_VMS_ITEM_ID;
         });
      }
   }

   angular.module("com.vmware.vsphere.client.network")
         .service("vmMigrateSelectVmsPageService", VmMigrateSelectVmsPageService);
}
